/* eslint-disable comma-dangle, no-var, react/forbid-prop-types, react/jsx-closing-bracket-location, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var InfoTip = require("../components/info-tip.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var TextListEditor = require("../components/text-list-editor.jsx");

var MatcherEditor = React.createClass({
    displayName: "MatcherEditor",

    propTypes: {
        left: React.PropTypes.array,
        right: React.PropTypes.array,
        labels: React.PropTypes.array,
        orderMatters: React.PropTypes.bool,
        padding: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            left: ["$x$", "$y$", "$z$"],
            right: ["$1$", "$2$", "$3$"],
            labels: ["test", "label"],
            orderMatters: false,
            padding: true
        };
    },

    render: function render() {
        var _this = this;

        return React.createElement(
            "div",
            { className: "perseus-matcher-editor" },
            React.createElement(
                "div",
                null,
                " ",
                "Correct answer:",
                " ",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Enter the correct answers here. The preview on the right will show the cards in a randomized order, which is how the student will see them."
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-clearfix" },
                React.createElement(TextListEditor, {
                    options: this.props.left,
                    onChange: function onChange(options, cb) {
                        _this.props.onChange({ left: options }, cb);
                    },
                    layout: "vertical"
                }),
                React.createElement(TextListEditor, {
                    options: this.props.right,
                    onChange: function onChange(options, cb) {
                        _this.props.onChange({ right: options }, cb);
                    },
                    layout: "vertical"
                })
            ),
            React.createElement(
                "span",
                null,
                " ",
                "Labels:",
                " ",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "These are entirely optional."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement("input", {
                    type: "text",
                    defaultValue: this.props.labels[0],
                    onChange: this.onLabelChange.bind(this, 0)
                }),
                React.createElement("input", {
                    type: "text",
                    defaultValue: this.props.labels[1],
                    onChange: this.onLabelChange.bind(this, 1)
                })
            ),
            React.createElement(
                "div",
                null,
                React.createElement(PropCheckBox, {
                    label: "Order of the matched pairs matters:",
                    orderMatters: this.props.orderMatters,
                    onChange: this.props.onChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "With this option enabled, only the order provided above will be treated as correct. This is useful when ordering is significant, such as in the context of a proof."
                    ),
                    React.createElement(
                        "p",
                        null,
                        "If disabled, pairwise matching is sufficient. To make this clear, the left column becomes fixed in the provided order and only the cards in the right column can be moved."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(PropCheckBox, {
                    label: "Padding:",
                    padding: this.props.padding,
                    onChange: this.props.onChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Padding is good for text, but not needed for images."
                    )
                )
            )
        );
    },

    onLabelChange: function onLabelChange(index, e) {
        var labels = _.clone(this.props.labels);
        labels[index] = e.target.value;
        this.props.onChange({ labels: labels });
    },

    getSaveWarnings: function getSaveWarnings() {
        if (this.props.left.length !== this.props.right.length) {
            return ["The two halves of the matcher have different numbers" + " of cards."];
        }
        return [];
    },

    serialize: function serialize() {
        return _.pick(this.props, "left", "right", "labels", "orderMatters", "padding");
    }
});

module.exports = MatcherEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/matcher-editor.jsx
 ** module id = 125
 ** module chunks = 0 1
 **/